import script from "./ChildComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChildComponent.vue?vue&type=script&setup=true&lang=js"

import "./ChildComponent.vue?vue&type=style&index=0&id=17a4ce9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a4ce9b"]])

export default __exports__